onDomReady(function () {
   /**
    * Sidebar navigation initialization
    */
   let togglers = $$('.expandRow'),
      elements = $$('.endpointsList'),
      openElement = -1; // Default to all closed

   // Get the index of the current endpoint that should be open.
   elements.each(function (item, index, array) {
      if (item.hasClass('open')) {
         openElement = index;
      }
   });

   let sideNav = new Fx.Accordion(togglers, elements, {
      display: openElement,
      opacity: false,
      initialDisplayFx: false,
      alwaysHide: true, // make it possible to close all elements
      onActive: function (toggler, element) {
         let icon = toggler.getChildren()[0];
         icon.removeClass('fa fa-caret-right');
         icon.addClass('fa fa-caret-down');
         toggler.addClass('active');
      },
      onBackground: function (toggler, element) {
         let icon = toggler.getChildren()[0];
         icon.removeClass('fa fa-caret-down');
         icon.addClass('fa fa-caret-right');
         toggler.removeClass('active');
      },
   });

   /**
    * Sidebar navigation initialization
    */
   let endpoints = $$('.toggleContent');

   endpoints.addEvent('click', function (ev) {
      let target = ev.target.get('tag') === 'i' ? ev.target.getParent() : ev.target,
         icon = target.getChildren()[0],
         expanded = icon.hasClass('fa-angle-double-up'),
         bodyContent = target.getPrevious().getChildren('.bodyContent').pick();

      if (expanded) {
         let fx = new Fx.SmoothScroll().toElement(target.getParent('.endpoint'));
         fx.chain(function () {
            bodyContent.toggle();
         });
      } else {
         bodyContent.toggle();
      }

      icon.toggleClass('fa-angle-double-down', expanded);
      icon.toggleClass('fa-angle-double-up', !expanded);
   });
});
